import { useState } from "react"
import type { ListRequest } from "@/shared/types/commonResponse"
import { useVideoListQuery } from "@/service/api/video"
import { STAR_ID } from "@/shared/constants/star"
import MainTitle from "../MainTitle"
import VideoItem from "./VideoItem"
import { useInView } from "react-intersection-observer"

const Video = () => {
  const [videoList] = useState<ListRequest>({
    Language: "en",
    angkorId: "",
    requestDto: {
      pageable: {
        page: 0,
        size: 1000,
        sort: [],
      },
      searchKeyword: "",
      starId: STAR_ID,
    },
  })

  const { ref, inView } = useInView({ triggerOnce: true })

  const { data: videoListData = { content: [] } } = useVideoListQuery(
    videoList,
    {
      enabled: inView,
    }
  )

  return (
    <div className="mb-5" ref={ref}>
      <MainTitle title="Video" link="video" />

      <div className="overflow-x-auto px-4 mr-4">
        <div className="flex flex-nowrap gap-2.5">
          {videoListData.content.slice(0, 5).map((item, i) => (
            <VideoItem
              key={`${item.id}-${i}`}
              id={item.id}
              title={item.title}
              image={item.thumbImageUrl}
              date={item.regDt}
              videoList={videoListData.content}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default Video
